import { getStack } from '@/utils/stackUtils';
import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN;
const environment = getStack();

const ignoreErrors = [/status code 400/im, /Request failed with status code 401/im];

if (dsn) {
  Sentry.init({
    dsn,
    integrations: [
      ...(environment === 'staging'
        ? [
            Sentry.replayIntegration({
              maskAllText: false,
              blockAllMedia: false,
            }),
          ]
        : []),
    ],
    ...(environment === 'staging'
      ? {
          replaysSessionSampleRate: 0.1,
          replaysOnErrorSampleRate: 1.0,
        }
      : {}),
    ignoreErrors,
    environment,
  });
}
